import { render, staticRenderFns } from "./PopupExportCSV.vue?vue&type=template&id=2b07a0aa&scoped=true&"
import script from "./PopupExportCSV.vue?vue&type=script&lang=js&"
export * from "./PopupExportCSV.vue?vue&type=script&lang=js&"
import style0 from "./PopupExportCSV.vue?vue&type=style&index=0&id=2b07a0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07a0aa",
  null
  
)

export default component.exports